import React, { Fragment, useEffect, useState, useMemo } from 'react';
import { handleSortBy, pColmDisplay, GenerateCertificatePdf, getLastURL, capitalizeFirstLetterWithOnlyLetter, RatingDisplay, CompanyNameDisplay, totalPriceDisplay, PriceCTDisplay, handleSortByAction, totalPriceDisplayforDiscount, totalCarat   , totalPriceDisplayForDiamond , PriceCTDisplayForDiamond , totalPriceDisplayforDiscountForDiamond, appendDetailsNewTabQuery} from '../../../helper';
import { useSelector, useDispatch } from 'react-redux';
import { url, postPerPage, hrdurl, giaurl } from '../../../config';
import { IMAGES, SEARCH_LIMIT_MSG } from '../../../constants';
import { useHistory } from 'react-router';
import ReactPaginate from "react-paginate";
import { useAlert } from 'react-alert';
import $, { isArray } from 'jquery';
import { getProductsFilterByAscending, getAllProductsCompare, getAllProducts, getUrlToDownloadDocument  , getAllDiamondsProducts , getDiamondsProductsFilterByAscending , getUrlToDownloadDocumentdiamonds , getAllDiamondsProductsCompare, DIAMOND_MARKET_DEFAULT_SORT} from '../../../actions/productActions';
import { Link } from 'react-router-dom';
import { getAllProductsFilter , getAllDiamondsProductsFilter } from '../../../actions/productActions';
import { diamondsJson, listProductAction } from '../../../utils/json';
import { useLocation } from 'react-router';
import PopupConfirm from '../../layout/PopupConfirm';
import mixpanel from 'mixpanel-browser';
import { FormattedMessage, useIntl } from 'react-intl';
import { DOWNLOAD_FAIL } from '../../../constants/productConstants';
import { comaSeperatedFilter  , comaSeperatedFilterfForSeller} from '../../../helper';
import TableNavbar from './tableNav';

function areDiamondMutualPair(a, b) {
    if (!a || !b) {
        return false;
    }
    const as = String(a.stock_number ?? '').trim();
    const ap = String(a.pair_stock_no ?? '').trim();
    const bs = String(b.stock_number ?? '').trim();
    const bp = String(b.pair_stock_no ?? '').trim();
    if (!as || !ap || !bs || !bp) {
        return false;
    }
    return as === bp && ap === bs;
}

/** Matched pairs: merge two API rows into one display row (pair_sort_id and/or mutual stock link). */
function buildDiamondDisplayRows(dataList, matchedPairs) {
    if (!dataList || !dataList.length) return [];
    if (!matchedPairs) {
        return dataList.map((item) => ({ kind: 'one', items: [item] }));
    }
    // Keep API order: backend sorts pairs (e.g. price/carat) then returns the two stones consecutively.
    const sorted = [...dataList];
    const out = [];
    let i = 0;
    while (i < sorted.length) {
        const a = sorted[i];
        const b = sorted[i + 1];
        const samePairId =
            b &&
            a.pair_sort_id != null &&
            b.pair_sort_id != null &&
            String(a.pair_sort_id) === String(b.pair_sort_id);
        const mutual = b && areDiamondMutualPair(a, b);
        if (samePairId || mutual) {
            out.push({ kind: 'pair', items: [a, b] });
            i += 2;
        } else {
            out.push({ kind: 'one', items: [a] });
            i += 1;
        }
    }
    return out;
}

function normalizeDiamondRowId(id) {
    if (id === null || id === undefined || id === '') {
        return null;
    }
    const n = Number(id);

    return Number.isFinite(n) && !Number.isNaN(n) ? n : id;
}

/** Opens a URL in a new tab without window.open features string (helps avoid 2nd-tab popup blocking). */
function openDetailHrefInNewTab(href) {
    if (!href) {
        return;
    }
    let absolute;
    try {
        absolute = new URL(href, window.location.href).href;
    } catch (e) {
        absolute = href;
    }
    const a = document.createElement('a');
    a.href = absolute;
    a.target = '_blank';
    a.rel = 'noopener noreferrer';
    a.style.display = 'none';
    document.body.appendChild(a);
    a.click();
    a.remove();
}

function openBothDiamondDetailTabs(baseUrl, id1, id2, event) {
    if (event) {
        event.preventDefault();
        event.stopPropagation();
    }
    const n1 = normalizeDiamondRowId(id1);
    const n2 = normalizeDiamondRowId(id2);
    if (n1 == null || n2 == null) {
        return;
    }
    const root = String(baseUrl || '').replace(/\/$/, '');
    const path1 = appendDetailsNewTabQuery(
        root ? `${root}/details/diamonds/${n1}` : `/details/diamonds/${n1}`
    );
    const path2 = appendDetailsNewTabQuery(
        root ? `${root}/details/diamonds/${n2}` : `/details/diamonds/${n2}`
    );
    // Two synchronous synthetic <a> clicks (same user gesture) — more reliable than double window.open.
    openDetailHrefInNewTab(path1);
    openDetailHrefInNewTab(path2);
}

/** Matches how rows persist selected IDs to sessionStorage (see handleSelectPair). */
function readSelectedProductIdsFromSession() {
    const raw = sessionStorage.getItem('selected_products');
    if (!raw || !String(raw).trim()) {
        return [];
    }
    return String(raw)
        .split(',')
        .map((s) => s.trim())
        .filter(Boolean)
        .map((s) => Number(s))
        .filter((n) => !Number.isNaN(n));
}

const WhiteDimonds = (props) => {

    const history = useHistory();
    const alert = useAlert();
    const dispatch = useDispatch();
    const location = useLocation();
    const intl = useIntl();

    const category_slug = getLastURL(location);
    const { products, error, loading } = useSelector(state => state.products);
    const documentDetailState = useSelector(state => state.downloadState);
    const productFilter = useSelector(state => state.DownloadPdfWithFilterState)
    const [postsPerPage, setPostPerPage] = useState(postPerPage);
    const diamondSortLabel = (sort) => {
        const match = diamondsJson.find(
            (item) => item.value === sort?.order_by_value && item.type === sort?.order_by_type
        );
        return match?.display_name || <FormattedMessage id="Discount: Low to High" />;
    };

    const readDiamondSortLabel = () => {
        try {
            const stored = JSON.parse(localStorage.getItem(category_slug + '_sorting') || 'null');
            if (stored?.order_by_value && stored?.order_by_type && stored.order_by_value !== 'id') {
                return diamondSortLabel(stored);
            }
        } catch (e) {
            // show the default label when stored sort cannot be read
        }
        return diamondSortLabel(DIAMOND_MARKET_DEFAULT_SORT);
    };

    const [filterdisplayname, setFilterDisplayName] = useState(readDiamondSortLabel);
    const [search, setSearch] = useState();
    const [selectAllCompare, setSelectAllCompare] = useState(new Array(documentDetailState?.documentDetail?.products?.data).fill(false));
    const [selectedId, setSelectedId] = useState([]);
    const [pageNumber, setPageNumber] = useState(props.pageNumber && props.pageNumber);
    const [activeFilters, setActiveFilters] = useState([]);


    const [popUpLimitTitle, setpopUpLimitTitle] = useState(<FormattedMessage id="Search Limit Finished" />);
    const [popUpLimitMessage, setpopUpLimitMessage] = useState(SEARCH_LIMIT_MSG);
    const [productsData, setproductsData] = useState();
    const [pageCount , setPageCount] = useState(0)
    const [pageGuardKey, setPageGuardKey] = useState(0)

    const matchedPairsActive = useMemo(() => {
        const na = props?.newactiveFilters;
        const fromProps = na && (na.matched_pairs === true || na.matched_pairs === '1');
        const fromApi =
            products?.filter &&
            (products.filter.matched_pairs === '1' || products.filter.matched_pairs === true);
        return !!(fromProps || fromApi);
    }, [props?.newactiveFilters, products?.filter]);

    const displayRows = useMemo(() => {
        return buildDiamondDisplayRows(productsData || [], matchedPairsActive);
    }, [productsData, matchedPairsActive]);

    useEffect(() => {
        const len = displayRows?.length || 0;
        setSelectAllCompare(new Array(len).fill(false));
    }, [displayRows?.length, matchedPairsActive]);

    const handleSelectPair = (position, id1, id2) => {
        const pairIds = [...new Set([normalizeDiamondRowId(id1), normalizeDiamondRowId(id2)].filter((x) => x != null))];
        if (pairIds.length === 0) {
            return;
        }
        const sameId = (a, b) => String(a) === String(b);
        setSelectAllCompare((prev) =>
            (prev || []).map((item, index) => (index === position ? !item : item))
        );
        setSelectedId((prev) => {
            const prevList = Array.isArray(prev) ? prev.map(normalizeDiamondRowId).filter((x) => x != null) : [];
            const allIn =
                pairIds.length > 0 && pairIds.every((id) => prevList.some((p) => sameId(p, id)));
            let merged;
            if (!allIn) {
                merged = [...prevList];
                for (const id of pairIds) {
                    if (!merged.some((p) => sameId(p, id))) {
                        merged.push(id);
                    }
                }
            } else {
                merged = prevList.filter((p) => !pairIds.some((id) => sameId(p, id)));
            }
            sessionStorage.setItem('selected_products', merged.join(','));
            return merged;
        });
    };

    useEffect(() => {
       sessionStorage.removeItem('selected_products') 
    },[])
    useEffect(() => {
        if (!documentDetailState?.error) {
            return;
        }
        const exportError = documentDetailState.error;
        const exportMessage = typeof exportError === 'string' ? exportError : exportError?.message;
        if (exportMessage) {
            alert.error(exportMessage);
        }
        dispatch({
            type: DOWNLOAD_FAIL,
            payload: null
        })
    }, [documentDetailState?.error])

    useEffect(() => {
        if (error) {
            alert.error(error);
            return;
        }
        if (documentDetailState?.documentDetail?.pdf_url) {
            if (productFilter?.data?.filter?.seller) {
                sessionStorage.setItem('isSellerFilter', true)
            }
            const link = document.createElement('a');
            link.target = '__blank';
            link.href = documentDetailState?.documentDetail?.pdf_url;
            // link.download = 'diamonds.pdf';
            document.body.appendChild(link);
            link.click();

            //reset state to prevent re-downloading.
            dispatch({
                type: DOWNLOAD_FAIL,
                payload: null
            })
        }
    }, [documentDetailState?.documentDetail])

    const handleResForm = (status) => {
        if (status) {
            $("#dismiss-modal").trigger('click');
            history.push({ pathname: url + '/plan-details' });
        }
    }

    const handlePageChange = ({ selected }) => {
        // Pages are 1-based in the pager. selected 0 is page 1. Block page 6 and above.
        if (selected + 1 > 5) {
            alert.error(intl.formatMessage({
                id: 'ChangeFiltersToViewMore',
                defaultMessage: 'Change your filters to view more listings.'
            }));
            setPageGuardKey((key) => key + 1);
            return;
        }
        setPageNumber(selected)
        props.updateResetPageHandler(selected)
        dispatch(getAllDiamondsProducts(category_slug, (selected + 1)));
        // setDisableInitialCallback(0);
    }

    // const pageCount = Math.ceil((products?.products?.total) / postsPerPage);

    const handleAcendingFilter = (value, type, displayname) => {
        setFilterDisplayName(displayname)
        $('.sort_by_list').css({
            display: "none"
        })
        props.tabChangeHandler(1)

        const getSelected  = sessionStorage.getItem('selected_products')
        const payload = { order_by_type: type, order_by_value: value }
        let filter = props?.newactiveFilters ? {...props?.newactiveFilters} : {}
        if(getSelected){
            const productIds = getSelected?.split(',')?.map(Number);
            filter = { compare_product_ids :productIds }
        }
        sessionStorage.setItem('discountDetails', JSON.stringify(payload))
        dispatch(getUrlToDownloadDocumentdiamonds('RESET'));
        dispatch(getDiamondsProductsFilterByAscending(category_slug, value, type , filter))
    }

    const handleListFilter = (value, type, displayname) => {
        $('.sort_by_list').css({
            display: "none"
        })
        if (value == 'pdf') {
            //  setGetPdf(true)
            handleCompare(true, value)
        } else if (value === 'pdf_all' || value === 'excel_all') {
            handleCompare(true, value)
        } else {
            handleCompare(false)
        }
    }

    const handleSearch = (e) => {
        setSearch(e.target.value);
    }

    const handleSearchFilter = (e) => {
        mixpanel.track('Search Diamond')
        if (e.key === 'Enter') {
            dispatch(getAllDiamondsProductsFilter(category_slug, { search: search }));
        }
    }
    const handleSearchIconClick = () => {
        mixpanel.track('Search Diamond');
        dispatch(getAllDiamondsProductsFilter(category_slug, { search: search }));
    };

    const handleSelectCompare = (id, position) => {
        const nid = normalizeDiamondRowId(id);
        if (nid == null) {
            return;
        }
        const rowId = Number(nid);
        const useNumeric = !Number.isNaN(rowId);
        setSelectAllCompare((prev) =>
            (prev || []).map((item, index) => (index === position ? !item : item))
        );
        setSelectedId((prev) => {
            const prevList = Array.isArray(prev) ? [...prev] : [];
            const prevNorm = useNumeric ? prevList.map((x) => Number(x)) : prevList;
            const has = useNumeric ? prevNorm.includes(rowId) : prevList.includes(nid);
            let merged;
            if (!has) {
                merged = useNumeric ? [...new Set([...prevNorm.filter((x) => !Number.isNaN(x)), rowId])] : [...prevList, nid];
            } else {
                merged = useNumeric
                    ? prevNorm.filter((x) => !Number.isNaN(x) && x !== rowId)
                    : prevList.filter((x) => x !== nid);
            }
            sessionStorage.setItem('selected_products', merged.join(','));
            return merged;
        });
    }

const handleCompare = (getPdf, type) => {
        const fromSession = readSelectedProductIdsFromSession();
        const selectionIds =
            fromSession.length > 0
                ? fromSession
                : (selectedId || []).map((x) => Number(x)).filter((n) => !Number.isNaN(n));

        if (type === 'pdf_all' || type === 'excel_all') {
            let filter = props?.newactiveFilters ? {...props?.newactiveFilters} : {}
            const getPdftypes = type == 'pdf_all' ? true : false
            if(selectionIds?.length > 0){
            return dispatch(getUrlToDownloadDocumentdiamonds(category_slug, selectionIds, getPdftypes,type, filter));
            }else{
                return dispatch(getUrlToDownloadDocumentdiamonds(category_slug, [], getPdftypes, type, filter));
            }
        }

        if (selectionIds?.length > 0) {
        let filter = props?.newactiveFilters ? {...props?.newactiveFilters} : {}
            dispatch(getUrlToDownloadDocumentdiamonds(category_slug, selectionIds, getPdf , filter));
            setSelectAllCompare(new Array(selectionIds?.length)?.fill(true))
        }
         else {
            alert.error('Please select product');
            return;
        }
    }
    const handleCompareRemove = (id) => {
        if (selectedId?.includes(id)) {
            selectedId?.splice(selectedId?.indexOf(id), 1);
        }
        dispatch(getAllDiamondsProductsCompare(category_slug, selectedId))
    }

    const handleDeselectAll = () => {
        setSelectedId([]);
        setSelectAllCompare(new Array(displayRows?.length || 0).fill(false))
        dispatch({
            type: DOWNLOAD_FAIL,
            payload: null
        })
        dispatch(getAllDiamondsProductsCompare(category_slug, [], false))

    }

    useEffect(() => {
        if (products?.overlimit) {
            alert.error(products?.message)
            setTimeout(() => {
                window.location.href = url + '/plan-details'
            }, 1000);
            //Your search limit is exhausted. Upgrade and enjoy unlimited search.
            //Arama sınırınız doldu. Yükseltin ve sınırsız aramanın tadını çıkarın.
        }
        if (documentDetailState && documentDetailState?.documentDetail?.is_compare) {
            setproductsData(documentDetailState?.documentDetail?.products?.data)
            setPageCount(Math.ceil((documentDetailState?.documentDetail?.products?.total) / postsPerPage) )
        } else {
            setproductsData(products?.products?.data)
            setPageCount(Math.ceil((products?.products?.total) / postsPerPage) )
        }
    }, [products, documentDetailState])

    products && products?.over_limit &&
        $("#popup-click-confirm").trigger('click')

        //   const handleFilter = (keyToRemove) => {
        //         const updatedFilter = Object.entries(activeFilters).filter(([key]) => key !== keyToRemove).reduce((acc, [key, value]) => {
        //              if(key === 'carat' || key === 'no_BGM') {
        //                 acc[key] = value;
        //                 return acc;
        //              }
        //              if(key == 'is_fancy') {
        //                 acc[key] = value;
        //                 return acc;
        //              }
        //              if(key === 'price') {
        //                 acc[key] = value;
        //                 return acc;
        //              }
        //             acc[key] = value.map(item => item.attribute_id);
        //             return acc;
        //         }, {})
        //         setActiveFilters(updatedFilter);
        //         dispatch(getAllDiamondsProductsFilter(category_slug, updatedFilter));
        //         return
        // };

const handleFilter = (keyToRemove) => {
    const keysToRemove = keyToRemove === 'is_fancy' ? ['is_fancy', 'fancy_color', 'fancy_intensity', 'fancy_overtone'] : [keyToRemove];
    const updatedFilter = Object.entries(activeFilters)
        .filter(([key]) => !keysToRemove.includes(key))
        .reduce((acc, [key, value]) => {
            if (['carat', 'no_BGM', 'matched_pairs', 'is_fancy', 'price'].includes(key)) {
                acc[key] = value;
                    return acc;
            }
            if (['seller'].includes(key)) {
                acc[key] = value.map(item => item?.value);
                    return acc;
            }
             else {
                acc[key] = value.map(item => item.attribute_id);
                    return acc;
                
            }
            return acc;
        }, {});

    setActiveFilters(updatedFilter);
    props?.setNewactiveFilters(updatedFilter)
    dispatch(getAllDiamondsProductsFilter(category_slug, updatedFilter));
};


    useEffect(()=>{
       if(products?.filter && Object.keys(products?.filter).length > 0){
        setActiveFilters(products?.filter)
       }
    },[products?.filter])   
    

    return (
            <Fragment>
                <div className="col-lg-12">
                    <div className="dashboard-content table-filter-area">
                        <div className="filter_search_right">
                            <div className="search_cat_top">
                                {/* <div className="row">
                                    <div className="col-lg-12 col-md-12 col-sm-12">
                                        <Link to={`${url}/advertised-products`}>
                                            <center>
                                                {localStorage.getItem('lang') === 'tr' ? (
                                                    <img src={ad_image1} className="mb-2 w-100" alt="Ad 1" />
                                                ) : (
                                                    <img src={ad_image} className="mb-2 w-100" alt="Ad" />
                                                )}
                                            </center>
                                        </Link>
                                    </div>  
                                </div> */}
                                <div className="row table-filter-row mx-0">
                                    <div className="col-lg-6 col-md-6 col-sm-6 pl-0">
                                        <button className='all-filters-btn' onClick={() => { props?.setShowFilters(!props?.showFilters) }} type='button'><img src={IMAGES.filterIcon} alt="filter-icon" loading="lazy" />
                                            <FormattedMessage
                                                id="addsingleproduct.all-filters"
                                                defaultMessage="All Filters"
                                            />
                                        </button>
                                        {/* <div className="c_box1 c_btn mb-2"> */}
                                        {/* <button className="btn btn-black compare-product-btn" type="button" onClick={handleCompare}><span className="mr-1"><img src={IMAGES.COMPARE_IMG} alt="" /></span> Compare products</button> */}
                                        {/* </div> */}
                                        {/* {
                                            $.map(products && products?.filter, (val, key) => {
                                                const isBgmKey = key === 'no_BGM';
                                                const displayText = isBgmKey && val == "1" ? 'No BGM' : '';
                                                if (isBgmKey) {
                                                    return (
                                                        <div className="s_c" key={key}>
                                                            <p>
                                                                <span className='first-letter'>
                                                                    <b>No BGM:</b> {displayText}
                                                                </span>
                                                            </p>
                                                        </div>
                                                    );
                                                } else {
                                                    return (
                                                        <div className="s_c" key={key}>
                                                            <p>
                                                                <span className='first-letter'>
                                                                    <b>{key}:</b> {val}
                                                                </span>
                                                            </p>
                                                        </div>
                                                    );
                                                }
                                            })
                                        } */}

                                        {
                                            //Kartik's code
                                            products?.filter && Object.entries(products?.filter)?.map(([filterName, filterArr]) => {
                                                if (filterName == 'type') {
                                                        return
                                                      }
                                                 if(filterName == 'carat' || filterName == 'price'){
                                                    return (
                                                    <div className="s_c" key={filterName}>
                                                            <p style={{marginLeft:'10px'}}>
                                                                <span className='first-letter'>
                                                                    <b>{filterName}</b> {filterArr?.from} - {filterArr?.to}
                                                                </span>
                                                                <button
                                                            className='text-black border-0 p-0 bg-none ml-3'
                                                            style={{ outline: 'none' }}
                                                            onClick={() => handleFilter(filterName)}
                                                        >
                                                            <i className='icon-close_1 ml-0'></i>
                                                        </button>
                                                            </p>
                                                        </div>
                                                    )
                                                }
                                                if(filterName == 'seller'){
                                                    return (
                                                    <div className="s_c" key={filterName}>
                                                            <p style={{marginLeft:'10px'}}>
                                                                <span className='first-letter'>
                                                                    <b>{filterName}</b> :  {Array.isArray(filterArr) ? comaSeperatedFilterfForSeller(filterArr) : filterArr}
                                                                </span>
                                                                <button
                                                            className='text-black border-0 p-0 bg-none ml-3'
                                                            style={{ outline: 'none' }}
                                                            onClick={() => handleFilter(filterName)}
                                                        >
                                                            <i className='icon-close_1 ml-0'></i>
                                                        </button>
                                                            </p>
                                                        </div>
                                                    )
                                                }
                                                if(filterName == 'is_fancy'){
                                                    return (
                                                    <div className="s_c" key={filterName}>
                                                            <p style={{marginLeft:'10px'}}>
                                                                <span className='first-letter'>
                                                                    <b>Fancy</b>: {filterArr == '1' ? 'Yes' : 'No'}
                                                                </span>
                                                                <button
                                                            className='text-black border-0 p-0 bg-none ml-3'
                                                            style={{ outline: 'none' }}
                                                            onClick={() => handleFilter(filterName)}
                                                        >
                                                            <i className='icon-close_1 ml-0'></i>
                                                        </button>
                                                            </p>
                                                        </div>
                                                    )
                                                }
                                                 if(filterName == 'no_BGM'){
                                                 return
                                                  }
                                                if (filterName === 'matched_pairs') {
                                                    return (
                                                        <div className="s_c" key={filterName}>
                                                            <p style={{ marginLeft: '10px' }}>
                                                                <span className="first-letter">
                                                                    <b><FormattedMessage id="diamonds.matched_pairs" defaultMessage="Matched Pairs" /></b>: <FormattedMessage id="addsingleproduct.Yes" defaultMessage="Yes" />
                                                                </span>
                                                                <button
                                                                    className="text-black border-0 p-0 bg-none ml-3"
                                                                    style={{ outline: 'none' }}
                                                                    onClick={() => handleFilter(filterName)}
                                                                >
                                                                    <i className="icon-close_1 ml-0"></i>
                                                                </button>
                                                            </p>
                                                        </div>
                                                    );
                                                }
                                                 else {
                                                    return (
                                                        <div className="s_c" key={filterName}>
                                            
                                                            <p style={{marginLeft:'10px'}}>
                                                                <span className='first-letter'>
                                                                    {filterName}: {Array.isArray(filterArr) ? comaSeperatedFilter(filterArr) : filterArr}
                                                                </span>
                                                                 <button
                                                            className='text-black border-0 p-0 bg-none ml-3'
                                                            style={{ outline: 'none' }}
                                                            onClick={() => handleFilter(filterName)}
                                                        >
                                                            <i className='icon-close_1 ml-0'></i>
                                                        </button>
                                                            </p>
                                                        </div>
                                                    )
                                                }
                                            })
                                        }
                                    </div>
                                    <div className="col-lg-6 col-md-6 col-sm-6 diamond pr-0">
                                        <div className='d-flex justify-content-end flex-wrap btn-group-row'>
                                            <div className="form-group sort_by_box d-flex justify-content-end">
                                                <p className="sort_b_h text-right" onClick={handleSortByAction}><b className="mr-2"><FormattedMessage id="Select Actions" />:</b><FormattedMessage id="Actions" /> <span className="icon-chevron_down"></span></p>
                                                <div className="sort_by_action">
                                                    <ul>
                                                        {
                                                            listProductAction && listProductAction?.map((data, key) => {
                                                                return (
                                                                    <li className="activessff" onClick={() => handleListFilter(data?.value, data?.type, data?.display_name)} key={key}>{data?.display_name}</li>
                                                                )
                                                            })
                                                        }
                                                    </ul>
                                                </div>
                                            </div>
                                            <div className="form-group sort_by_box d-flex justify-content-end">

                                                <p className="sort_b_h" onClick={handleSortBy}><b>
                                                    <FormattedMessage id="Sort_By" defaultMessage="Sort By" />:</b>{filterdisplayname}<span className="icon-chevron_down"></span></p>
                                                <div className="sort_by_list">
                                                    <ul>
                                                        {
                                                            diamondsJson && diamondsJson?.map((data, key) => {
                                                                if(!['views_count', 'favorite_count'].includes(data?.value)){
                                                                return (
                                                                    <li className="activess" onClick={() => handleAcendingFilter(data?.value, data?.type, data?.display_name)} key={key}>{data?.display_name}</li>
                                                                )
                                                                }
                                                            })
                                                        }
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                {/* {
                                    products && products.pdf_url && products.pdf_url.length > 0 &&
                                        <div className="row pdf_download_row text-right">
                                            
                                            <a href={products.pdf_url} target="_blank" className="not_a" id="download-pdf"  download={true}>Click here for download <img src={IMAGES.DOWNLOAD_SVG} /></a>
                                    
                                        </div>
                            } */}

                            </div>
                            <div className="form-group seach_filter row justify-content-end">
                                <div className="col-xl-8 col-lg-6 col-md-6 col-sm-6">
                                    <TableNavbar products={products} />
                                </div>

                                <div className="col-xl-4 col-lg-6 col-md-6 col-sm-6 text-right">
                                    <div className='position-relative d-inline-block mw-100'>
                                        <input
                                            type="text"
                                            value={search}
                                            onKeyPress={(e) => handleSearchFilter(e)}
                                            onChange={handleSearch}
                                            className="form-control"
                                            placeholder={intl.formatMessage({ id: 'SearchBySeller' })}
                                        />
                                        <span className="icon-search_1  input_icon" onClick={handleSearchIconClick} style={{ cursor: 'pointer' }}></span>
                                    </div>
                                </div>
                            </div>
                            <div className="filter_table">
                                <div className="tbles">
                                    {(loading || documentDetailState?.loading) ? <div className="loader-line"></div> : ""}
                                    <table width="100%">
                                        <thead>
                                            <tr>
                                                <th width="5%"></th>
                                                <th><FormattedMessage id="Seller" defaultMessage="Seller" /></th>
                                                <th><FormattedMessage id="Rating" defaultMessage="Rating" /></th>
                                                <th><FormattedMessage id="Shape" defaultMessage="Shape" /></th>
                                                <th><FormattedMessage id="addsingleproduct.carat" defaultMessage="Carat" /></th>
                                                {
                                                    products && products?.is_fancy == 1 ?
                                                        <Fragment>
                                                            <th><FormattedMessage id="Intensity" defaultMessage="Intensity" /></th>
                                                            <th><FormattedMessage id="Overtone" defaultMessage="Overtone" /></th>
                                                        </Fragment> :
                                                        <Fragment>
                                                        </Fragment>
                                                }
                                                <th><FormattedMessage id="addsingleproduct.color" defaultMessage="Color" /></th>
                                                <th><FormattedMessage id="addsingleproduct.clarity" defaultMessage="Clarity" /></th>
                                                <th><FormattedMessage id="addsingleproduct.cut" defaultMessage="Cut" /></th>
                                                <th><FormattedMessage id="addsingleproduct.pol" defaultMessage="Pol" /></th>
                                                <th><FormattedMessage id="addsingleproduct.sym" defaultMessage="Sym" /></th>
                                                <th><FormattedMessage id="addsingleproduct.Fluor" defaultMessage="Fluor" /></th>
                                                <th><FormattedMessage id="addsingleproduct.Cert" defaultMessage="Cert" /></th>
                                                <th><FormattedMessage id="addsingleproduct.milky" defaultMessage="Milky" /></th>
                                                <th><FormattedMessage id="addsingleproduct.bgm" defaultMessage="BGM" /></th>
                                                <th><FormattedMessage id="addsingleproduct.media" defaultMessage="Media" /></th>
                                                <th><FormattedMessage id="addsingleproduct.status" defaultMessage="status" /></th>

                                                {
                                                    products && products?.is_fancy == 0 ?
                                                        <Fragment>
                                                            <th><FormattedMessage id="addsingleproduct.discount" defaultMessage="discount" /></th>
                                                        </Fragment> :
                                                        <Fragment>
                                                        </Fragment>
                                                }
                                                <th><FormattedMessage id="addsingleproduct.price_ct_d" /></th>
                                                <th><FormattedMessage id="addsingleproduct.price_total_d" /></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                displayRows?.length > 0 ?
                                                    displayRows?.map((row, key) => {
                                                        const data = row.items[0];
                                                        const data2 = row.items[1];
                                                        const isPair = row.kind === 'pair';
                                                        const cell2 = (renderOne) =>
                                                            isPair ? (
                                                                <>
                                                                    <span style={{ display: 'block' }}>{renderOne(data)}</span>
                                                                    <span style={{ display: 'block' }}>{renderOne(data2)}</span>
                                                                </>
                                                            ) : (
                                                                renderOne(data)
                                                            );
                                                        const pairCheckboxId = 'p' + data?.id + '-pair-' + data2?.id;
                                                        const pairDetailClick =
                                                            isPair && data?.id != null && data2?.id != null
                                                                ? (e) => openBothDiamondDetailTabs(url, data.id, data2.id, e)
                                                                : undefined;
                                                        return (
                                                            <tr key={isPair ? pairCheckboxId : data?.id}>
                                                                <td>
                                                                    <div className="form-group mb-0 mini checks inss">
                                                                        {isPair ? (
                                                                            <>
                                                                                <input
                                                                                    type="checkbox"
                                                                                    id={pairCheckboxId}
                                                                                    className="checkbox"
                                                                                    name="check"
                                                                                    checked={selectAllCompare[key]}
                                                                                    onChange={() => handleSelectPair(key, data?.id, data2?.id)}
                                                                                />
                                                                                <label htmlFor={pairCheckboxId}></label>
                                                                            </>
                                                                        ) : (
                                                                            <>
                                                                                <input
                                                                                    type="checkbox"
                                                                                    id={'p' + data?.id}
                                                                                    className="checkbox"
                                                                                    name="check"
                                                                                    checked={selectAllCompare[key]}
                                                                                    onChange={() => handleSelectCompare(data?.id, key)}
                                                                                />
                                                                                <label htmlFor={'p' + data?.id}></label>
                                                                            </>
                                                                        )}
                                                                    </div>
                                                                </td>
                                                                <td  >
                                                                    {cell2((p) => (
                                                                        <Link to={appendDetailsNewTabQuery(url + `/details/diamonds/${p?.id}`)} target="_blank" className="not_a" onClick={pairDetailClick}>
                                                                            <span>{CompanyNameDisplay(p)}</span>&nbsp;{"\n"} <br />
                                                                        </Link>
                                                                    ))}
                                                                </td>
                                                                <td>
                                                                    {cell2((p) => (
                                                                        <Link to={appendDetailsNewTabQuery(url + `/details/diamonds/${p?.id}`)} target="_blank" className="not_a" onClick={pairDetailClick}>
                                                                            <i style={{ color: "#003B75" }} className="fa fa-star mr-1"></i>
                                                                            {RatingDisplay('list', p.average_rating, p.total_rating)}
                                                                        </Link>
                                                                    ))}
                                                                </td>
                                                                <td>
                                                                    {cell2((p) => (
                                                                        <Link to={appendDetailsNewTabQuery(url + `/details/diamonds/${p?.id}`)} target="_blank" className="not_a" onClick={pairDetailClick}>
                                                                            {pColmDisplay(p, 'a_shape')}
                                                                        </Link>
                                                                    ))}
                                                                </td>
                                                                <td>
                                                                    {cell2((p) => (
                                                                        <Link to={appendDetailsNewTabQuery(url + `/details/diamonds/${p?.id}`)} target="_blank" className="not_a" onClick={pairDetailClick}>{p && p.carat && totalCarat(p)}
                                                                        </Link>
                                                                    ))}
                                                                </td>
                                                                {
                                                                    products && products?.is_fancy == 1 ?
                                                                        <>
                                                                            <td>
                                                                                {cell2((p) => (
                                                                                    <Link to={appendDetailsNewTabQuery(url + `/details/diamonds/${p?.id}`)} target="_blank" className="not_a" onClick={pairDetailClick}>
                                                                                        {pColmDisplay(p, 'a_fancy_intensity')}
                                                                                    </Link>
                                                                                ))}
                                                                            </td>
                                                                            <td>
                                                                                {cell2((p) => (
                                                                                    <Link to={appendDetailsNewTabQuery(url + `/details/diamonds/${p?.id}`)} target="_blank" className="not_a" onClick={pairDetailClick}>
                                                                                        {pColmDisplay(p, 'a_fancy_overtone')}
                                                                                    </Link>
                                                                                ))}
                                                                            </td>
                                                                            <td>
                                                                                {cell2((p) => (
                                                                                    <Link to={appendDetailsNewTabQuery(url + `/details/diamonds/${p?.id}`)} target="_blank" className="not_a" onClick={pairDetailClick}>
                                                                                        {pColmDisplay(p, 'a_fancy_color')}
                                                                                    </Link>
                                                                                ))}
                                                                            </td>
                                                                        </>
                                                                        :
                                                                        <td>
                                                                            {cell2((p) => (
                                                                                <Link to={appendDetailsNewTabQuery(url + `/details/diamonds/${p?.id}`)} target="_blank" className="not_a" onClick={pairDetailClick}>
                                                                                    {pColmDisplay(p, 'a_color')}
                                                                                </Link>
                                                                            ))}
                                                                        </td>

                                                                }
                                                                <td>
                                                                    {cell2((p) => (
                                                                        <Link to={appendDetailsNewTabQuery(url + `/details/diamonds/${p?.id}`)} target="_blank" className="not_a" onClick={pairDetailClick}>
                                                                            {pColmDisplay(p, 'a_clarity')}
                                                                        </Link>
                                                                    ))}
                                                                </td>
                                                                <td>
                                                                    {cell2((p) => (
                                                                        <Link to={appendDetailsNewTabQuery(url + `/details/diamonds/${p?.id}`)} target="_blank" className="not_a" onClick={pairDetailClick}>
                                                                            {p && p.a_cut && capitalizeFirstLetterWithOnlyLetter(pColmDisplay(p, 'a_cut'))}
                                                                        </Link>
                                                                    ))}
                                                                </td>
                                                                <td>
                                                                    {cell2((p) => (
                                                                        <Link to={appendDetailsNewTabQuery(url + `/details/diamonds/${p?.id}`)} target="_blank" className="not_a" onClick={pairDetailClick}>
                                                                            {p && p.a_polish && capitalizeFirstLetterWithOnlyLetter(pColmDisplay(p, 'a_polish'))}
                                                                        </Link>
                                                                    ))}
                                                                </td>

                                                                <td>
                                                                    {cell2((p) => (
                                                                        <Link to={appendDetailsNewTabQuery(url + `/details/diamonds/${p?.id}`)} target="_blank" className="not_a" onClick={pairDetailClick}>
                                                                            {p && p.a_symmetry && capitalizeFirstLetterWithOnlyLetter(pColmDisplay(p, 'a_symmetry'))}
                                                                        </Link>
                                                                    ))}
                                                                </td>
                                                                <td>
                                                                    {cell2((p) => (
                                                                        <Link to={appendDetailsNewTabQuery(url + `/details/diamonds/${p?.id}`)} target="_blank" className="not_a" onClick={pairDetailClick}>
                                                                            {p && p.a_fluorescence && capitalizeFirstLetterWithOnlyLetter(pColmDisplay(p, 'a_fluorescence'))}
                                                                        </Link>
                                                                    ))}
                                                                </td>

                                                                <td>
                                                                    {cell2((p) => {
                                                                        if (p && p?.certificate_url) {
                                                                            return <a href={GenerateCertificatePdf(p?.certificate_url)} target={GenerateCertificatePdf(p?.certificate_url)}>{pColmDisplay(p, 'a_certificate')}</a>
                                                                        }
                                                                        if (p && p.certificate == "422" && pColmDisplay(p, 'a_certificate') == "HRD") {
                                                                            return <a href={hrdurl + p.certificate_number} target="_blank">{pColmDisplay(p, 'a_certificate')}</a>
                                                                        }
                                                                        if (p && p.certificate == "25" && pColmDisplay(p, 'a_certificate') == "GIA") {
                                                                            return <a href={giaurl + p.certificate_number} target="_blank">{pColmDisplay(p, 'a_certificate')}</a>
                                                                        }
                                                                        return p ? pColmDisplay(p, 'a_certificate') : '';
                                                                    })}
                                                                </td>

                                                                <td>
                                                                    {cell2((p) => (
                                                                        <Link to={appendDetailsNewTabQuery(url + `/details/diamonds/${p?.id}`)} target="_blank" className="not_a" onClick={pairDetailClick}>
                                                                            {p && p.milky && capitalizeFirstLetterWithOnlyLetter(pColmDisplay(p, 'milky'))}
                                                                        </Link>
                                                                    ))}
                                                                </td>

                                                                <td>
                                                                    {cell2((p) => (
                                                                        <Link to={appendDetailsNewTabQuery(url + `/details/diamonds/${p?.id}`)} target="_blank" className="not_a" onClick={pairDetailClick}>
                                                                            {p && p.bgm == 1 ? 'No' : "Yes"}
                                                                        </Link>
                                                                    ))}
                                                                </td>

                                                                <td>
                                                                    {cell2((p) => (
                                                                        <Link className='table-icons-wrap' to={appendDetailsNewTabQuery(url + `/details/diamonds/${p?.id}`)} target="_blank" onClick={pairDetailClick}>
                                                                            <img className={p?.certificate_number ? '' : "img-disabled"} src={IMAGES.docIcon} alt="doc-icon" loading="lazy" />
                                                                            <img className={p?.has_image == '1' ? "" : "img-disabled"} src={IMAGES.imgIcon} alt="image-icon" loading="lazy" />
                                                                            <img className={(p?.has_video == '1' || p?.diamond_3d_link)  ? "" : 'img-disabled'} src={IMAGES.playIcon} alt="video-icon"  loading="lazy"/>
                                                                        </Link>
                                                                    ))}
                                                                </td>

                                                                <td>
                                                                    {cell2((p) => (
                                                                        <Link to={appendDetailsNewTabQuery(url + `/details/diamonds/${p?.id}`)} target="_blank" className="not_a" onClick={pairDetailClick}>
                                                                            {p && p.availability_status && capitalizeFirstLetterWithOnlyLetter(pColmDisplay(p, 'availability_status'))}
                                                                        </Link>
                                                                    ))}
                                                                </td>
                                                                {/* {data && data?.certificate_url ?
                                                                    <td><a href={GenerateCertificatePdf(data?.certificate_url)} target={GenerateCertificatePdf(data?.certificate_url)}>{pColmDisplay(data, 'a_certificate')}</a></td>
                                                                    :
                                                                    <td><a href={hrdurl+data.certificate_number} target="_blank">{pColmDisplay(data, 'a_certificate')}</a></td>
                                                                } */}

                                                                {
                                                                    products && products?.is_fancy == 0 ?
                                                                        <Fragment>
                                                                            <td>
                                                                                {cell2((p) => (
                                                                                    <Link
                                                                                        to={appendDetailsNewTabQuery(url + `/details/diamonds/${p?.id}`)}
                                                                                        target="_blank"
                                                                                        className="not_a"
                                                                                        onClick={pairDetailClick}>
                                                                                        {p && p?.updated_discount  ? totalPriceDisplayforDiscountForDiamond(p) : "--"}
                                                                                    </Link>
                                                                                ))}
                                                                            </td>
                                                                        </Fragment> :
                                                                        <Fragment>
                                                                        </Fragment>
                                                                }

                                                                <td>
                                                                    {cell2((p) => (
                                                                        <Link
                                                                            to={appendDetailsNewTabQuery(url + `/details/diamonds/${p?.id}`)}
                                                                            target="_blank"
                                                                            className="not_a"
                                                                            onClick={pairDetailClick}>
                                                                            {PriceCTDisplayForDiamond(p)}
                                                                        </Link>
                                                                    ))}
                                                                </td>
                                                                <td>
                                                                    {cell2((p) => (
                                                                        <Link
                                                                            to={appendDetailsNewTabQuery(url + `/details/diamonds/${p?.id}`)}
                                                                            target="_blank"
                                                                            className="not_a"
                                                                            onClick={pairDetailClick}>
                                                                            {totalPriceDisplayForDiamond(p)}
                                                                        </Link>
                                                                    ))}
                                                                </td>
                                                            </tr>
                                                        )
                                                    })
                                                    :
                                                    <tr>
                                                        <th colSpan="25"><FormattedMessage id="ProductNotFound" defaultMessage="Product not Found" /></th>
                                                    </tr>
                                            }
                                        </tbody>


                                    </table>
                                </div>


                                <div className='row my-4'>
                                    <div className='col-sm-7 col-lg-8'>
                                        <TableNavbar products={products} />
                                    </div>
                                    <div className='col-sm-5 col-lg-4'>
                                        <div className="table_pagination">
                                            <ReactPaginate
                                                key={pageGuardKey}
                                                previousLabel={<i className="icon icon-chevron_gray-left"></i>}
                                                nextLabel={<i className="icon icon-chevron_black"></i>}
                                                pageCount={pageCount}
                                                onPageChange={handlePageChange}
                                                containerClassName={"paginationBttns"}
                                                previousLinkClassName={"previousBttn"}
                                                nextLinkClassName={"nextBttn"}
                                                disabledClassName={"paginationDisabled"}
                                                activeClassName={"paginationActive"}
                                                forcePage={props?.pageReset}
                                                //initialPage={pageNumber && pageNumber}
                                                //renderOnZeroPageCount={null}
                                                disableInitialCallback={true}
                                            />
                                        </div>
                                    </div>
                                </div>



                                {/* <div className="compare_list">
                                    {
                                        documentDetailState?.documentDetail && documentDetailState?.documentDetail?.is_compare ?
                                            documentDetailState?.documentDetail && documentDetailState?.documentDetail?.products?.data?.map((data, key) => {
                                                return (
                                                    <div className="c_box1">
                                                        <i className="icon_b icon-minus" onClick={() => handleCompareRemove(data?.id, key)}></i>
                                                        <p className="font-14 black-3B "><b>{data.company_name}</b>${totalPriceDisplay(data)}</p>
                                                    </div>
                                                )
                                            })
                                            :
                                            null
                                    }
                                    {
                                        documentDetailState?.documentDetail && documentDetailState?.documentDetail?.is_compare
                                            ?
                                            <div className="c_box1">
                                                <i className="icon_black icon-minus" style={{ cursor: 'pointer' }} onClick={handleDeselectAll}></i>
                                                <p className="font-14 black-3B">Deselect all</p>
                                            </div>
                                            :
                                            null
                                    }

                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            {
                <PopupConfirm
                    message={popUpLimitMessage}
                    title={popUpLimitTitle}
                    handleResForm={handleResForm}
                />
            }
            </Fragment>

    )
}

export default WhiteDimonds